import React, { useMemo, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import moment from "moment";

import { TCLabel } from "../Label/TopCourtLabel";
import { TCInput, TCSelect } from "../Input/TopCourtInput";

function TCDateTime({
  label = "Start",
  value = null,
  onChange,
  dateOptions,
  disabledHours = [],
  disabledMinutes = [],
  minDate,
  maxDate,
  minuteStep = 5,
  disabled = false,
}) {

  const [ selection, setSelection ] = useState({
      date: null, 
      day: null,
      hours: null,
      minutes: null
  })

  useEffect(() => {
    if (selection.date && selection.hours && selection.minutes) {
      onChange(selection)
    }
  }, [selection])

  useEffect(() => {
    console.log('here check', selection.date, value, dateOptions)
    if (!selection.date && value || (selection.date && selection.date?.label != value.date)) {
      setSelection({
        ...value,
        date: value.date && dateOptions ? dateOptions.find((o) => o.label === value.date) || {label: value.date, value: value.date} : value.date,
        hours: value.hours ? hourOptions.find((o) => (o.label === value.hours) || (o.label === value.hours?.split(':')[0])) : hourOptions.find((o) => o.label === value.hours?.split(':')[0]) || null,
        minutes: value.minutes ? minuteOptions.find((o) => o.label === value.minutes) : minuteOptions.find((o) => o.label === value.hours?.split(':')[1]) || null
      })
    }
  }, [value])

  useEffect(() => {
    console.log('here selection', selection)
  }, [selection])

  // const allowedArray = useMemo(
  //   () => (Array.isArray(allowedDates) ? allowedDates.filter(Boolean) : []),
  //   [allowedDates]
  // );

  const minHour = useMemo(() => {
    const nums = (disabledHours || [])
      .map(h => parseInt(h, 10))
      .filter(Number.isFinite);
    return nums.length ? Math.min(...nums) : null; // '10' → 10
  }, [disabledHours]);

  const hourOptions = useMemo(() => {
    const all = Array.from({ length: 24 }, (_, h) => ({
      label: String(h).padStart(2, "0"),
      value: h,
    }));
    return minHour == null ? all : all.filter(o => o.value >= minHour);
  }, [minHour]);

  const minMinutes = useMemo(() => {
    const nums = (disabledMinutes || [])
      .map(h => parseInt(h, 10))
      .filter(Number.isFinite);
    return nums.length ? Math.min(...nums) : null; // '10' → 10
  }, [disabledMinutes]);

  const minuteOptions = useMemo(() => {
  const step = Math.max(1, Number(minuteStep) || 5);
  const count = Math.max(1, Math.ceil(60 / step));
  const opts = Array.from({ length: count }, (_, i) => {
    const m = Math.min(i * step, 59);
    return { label: String(m).padStart(2, "0"), value: m };
  });
  return minMinutes == null ? opts : opts.filter(o => o.value >= minMinutes);
}, [minuteStep, minMinutes]);

  // const allowedSet = useMemo(() => new Set(allowedArray), [allowedArray]);

  // const shouldDisableDate = (d) => {
  //   if (!d || !d.isValid()) return true;
  //   if (!allowedArray.length) return false;
  //   return !allowedSet.has(d.format("YYYY-MM-DD"));
  // };

  const setChange = (e) => {
    setSelection(prev => ({
      ...prev,
      ...e
    }))
  }

  useEffect(() => {
    console.log('here minDate', minDate, maxDate)
  }, [minDate, maxDate])

  return (
    <Grid container alignItems="center" wrap="nowrap">
      {/* Label */}
      {
        label &&
        <Grid item marginRight={0.6}>
          <TCLabel subtitle bold>
            {label}
          </TCLabel>
        </Grid>
      }
      <Grid item xs={8} sm={8} md={8}>
        <TCSelect
          placeHolder="DD/MM/YYYY"
          options={dateOptions}
          value={selection.date}
          onChange={(e) => {
            setChange({
              date: e
            })
          }}
          disabled={disabled}
          isSearchable={false}
          // inDialog={true}
          styles={{
              // overall height
              control: (base) => ({ ...base, 
                fontSize: '13px',
                border: '0.5px',
                backgroundColor: '#f8fafc',
                borderRadius: 2,
                minHeight: 28 
              }),

              // make the indicator area smaller (both chevron + clear X)
              dropdownIndicator: (base) => ({ ...base, padding: 2, width: 8 }),   // was ~8
              clearIndicator:    (base) => ({ ...base, padding: 2 }),
              indicatorsContainer: (base) => ({ ...base, paddingRight: 0, width: 8 }),

              // thinner/shorter separator (or hide with display:'none')
              indicatorSeparator: (base) => ({
                ...base,
                width: 1,
                marginTop: 6,
                marginBottom: 6,
                opacity: 0.6,
              }),
            }}
        />
      </Grid>
      {/* Hour */}
      <Grid item xs={2} sm={2} textAlign={"center"}>
        <TCSelect
          placeHolder="HH"
          options={hourOptions}
          value={selection.hours}
          onChange={(e) => {
            setChange({
              hours: e
            })
          }}
          isSearchable={false}
          disabled={disabled}
          // inDialog={true}
          styles={{
              // overall height
              control: (base) => ({ ...base, 
                fontSize: '13px',
                border: '0.5px',
                backgroundColor: '#f8fafc',
                borderRadius: 2,
                minHeight: 28 
              }),

              // make the indicator area smaller (both chevron + clear X)
              dropdownIndicator: (base) => ({ ...base, padding: 2, width: 8 }),   // was ~8
              clearIndicator:    (base) => ({ ...base, padding: 2 }),
              indicatorsContainer: (base) => ({ ...base, paddingRight: 0, width: 8 }),

              // thinner/shorter separator (or hide with display:'none')
              indicatorSeparator: (base) => ({
                ...base,
                width: 1,
                marginTop: 6,
                marginBottom: 6,
                opacity: 0.6,
              }),
            }}
        />
      </Grid>
      <Grid item style={{
        paddingTop:3, paddingBottom: 3,
        backgroundColor: '#f8fafc', textAlign: 'center'
      }}>
        <TCLabel>:</TCLabel>
      </Grid>
      {/* Minute */}
      <Grid item xs={2} sm={2} textAlign={"center"}>
        <TCSelect
          placeHolder="MM"
          options={minuteOptions}
          value={selection.minutes}
          onChange={(e) => {
            setChange({
              minutes: e
            })
          }}
          isSearchable={false}
          disabled={disabled}
          // inDialog={true}
          styles={{
              // overall height
              control: (base) => ({ ...base, 
                fontSize: '13px',
                border: '0.5px',
                backgroundColor: '#f8fafc',
                borderRadius: 2,
                minHeight: 28 
              }),

              // make the indicator area smaller (both chevron + clear X)
              dropdownIndicator: (base) => ({ ...base, padding: 2, width: 0 }),   // was ~8
              clearIndicator:    (base) => ({ ...base, padding: 2 }),
              indicatorsContainer: (base) => ({ ...base, paddingRight: 0, width: 0 }),

              // thinner/shorter separator (or hide with display:'none')
              indicatorSeparator: (base) => ({
                ...base,
                width: 1,
                marginTop: 6,
                marginBottom: 6,
                opacity: 0.6,
              }),
            }}
        />
      </Grid>
    </Grid>
  );
}

export default TCDateTime;